import React, { useState } from "react";
import { LanguageCreate, LanguageGetCreate } from "../../services/auth";
import { toastError, toastSuccess } from "../../config/ToastModal";

function CreateLanguage({ setModalClose, setCategoryData, handleCloseModal }) {
  const [category, setcategory] = useState("");

  const createcategorys = async () => {
    try {
      if (!category) {
        toastError("Please enter the language!");
      }
      if (category) {
        const data = {
          value: category,
        };
        const result = await LanguageCreate(data);
        if (result) {
          const response = await LanguageGetCreate();
          if (response) {
            setCategoryData(response?.data);
            toastSuccess("The language has been added successfully.");
          }
          setcategory("");
          handleCloseModal();
        } else {
          toastError("The language has already been created");
        }
      }
    } catch (error) {
    }
  };

  return (
    <div className="p-1">
      <div className="p-1">
        <div>
          <h3></h3>
        </div>

        <div>
          <div className="mt-3 mb-3 col-lg-12">
            <label>
              Language <span className="text-danger">*</span>
            </label>
            <input
              placeholder="Please enter Language..."
              onChange={(e) => setcategory(e.target.value)}
              value={category}
              name="category"
              style={{
                border: "1px solid #ececec",
                padding: "10px",
                borderRadius: "10px",
                width: "100%",
              }}
            />
          </div>

          <div className="mt-4 mb-5">
            <button onClick={createcategorys} className="btn-style-one">
              Create Language
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateLanguage;
